enum SocketType {
	ACTION_TYPE = 'action',
	AUTH_TYPE = 'auth',
}

export default SocketType;
